/**
 * Custom size dropdown for Length / Ring Size options.
 */
class SizeOptionDropdown extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-size-dropdown-trigger]');
    this.panel = this.querySelector('[data-size-dropdown-panel]');
    this.valueEl = this.querySelector('[data-size-dropdown-value]');
    this.formId = this.getAttribute('data-form-id');
    this.optionName = this.getAttribute('data-option-name');

    if (!this.trigger || !this.panel || this._bound) return;
    this._bound = true;

    this._onTriggerClick = this._onTriggerClick.bind(this);
    this._onDocumentClick = this._onDocumentClick.bind(this);
    this._onKeyDown = this._onKeyDown.bind(this);
    this._onChange = this._onChange.bind(this);

    this.trigger.addEventListener('click', this._onTriggerClick);
    document.addEventListener('click', this._onDocumentClick);
    this.addEventListener('keydown', this._onKeyDown);
    document.addEventListener('change', this._onChange);

    this._syncValue();
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this._onTriggerClick);
    document.removeEventListener('click', this._onDocumentClick);
    this.removeEventListener('keydown', this._onKeyDown);
    document.removeEventListener('change', this._onChange);
    this._bound = false;
  }

  _inputs() {
    return Array.from(this.querySelectorAll('input[data-option-position]'));
  }

  _syncValue() {
    const checked = this._inputs().find((input) => input.checked);
    const label = checked?.dataset.label || checked?.nextElementSibling?.textContent?.trim() || this.getAttribute('data-placeholder') || 'Select Size';
    if (this.valueEl) this.valueEl.textContent = label;
  }

  open() {
    this.panel.hidden = false;
    this.trigger.setAttribute('aria-expanded', 'true');
    this.classList.add('is-open');
  }

  close() {
    this.panel.hidden = true;
    this.trigger.setAttribute('aria-expanded', 'false');
    this.classList.remove('is-open');
  }

  toggle() {
    if (this.panel.hidden) this.open();
    else this.close();
  }

  _onTriggerClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.toggle();
  }

  _onDocumentClick(event) {
    if (!this.contains(event.target)) this.close();
  }

  _onKeyDown(event) {
    if (event.key === 'Escape') this.close();
  }

  _onChange(event) {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (!this.contains(target)) return;
    if (!target.matches('input[data-option-position]')) return;
    this._syncValue();
    this.close();
  }
}

if (!customElements.get('size-option-dropdown')) {
  customElements.define('size-option-dropdown', SizeOptionDropdown);
}
